import {
  ToastContext,
  type ToastContextType,
} from 'components/molecules/Toast/ToastContext';
import { useContext } from 'react';

export const useToast = (): ToastContextType | undefined =>
  useContext(ToastContext);
